import { STEP_TYPE_STATUSES } from 'constants/status.constants';
import { STEP_TYPES } from 'constants/status.constants';
import { PROVIDED_BY_ID } from 'features/testing-workflow/testing-workflow-details/testing-workflow-detais.interface';
import { ROLE_CODES } from 'constants/role.constants';

export const isStepSubmitted = stepStatus => {
  return stepStatus === STEP_TYPE_STATUSES.COMPLETED ||
    stepStatus === STEP_TYPE_STATUSES.PENDING_VERIFICATION ||
    stepStatus === STEP_TYPE_STATUSES.ARCHIVED;
};

export const isPendingVerificationStatus = stepStatus => {
  return stepStatus === STEP_TYPE_STATUSES.PENDING_VERIFICATION;
};

export const isVerificationStep = stepType => {
  return stepType ? stepType.id === STEP_TYPES.VERIFICATION : false;
};

export const isResponsibleOptionChecked = (responsibleRoles, option, completedByCertemy) => {
  if (responsibleRoles.length === 1 && option.roles.length === 1) {
    if (responsibleRoles[0].roleId !== ROLE_CODES.ORGANIZATION_ADMIN) {
      return responsibleRoles[0].roleId === option.roles[0];
    } else {
      return completedByCertemy
        ? option.id === PROVIDED_BY_ID.ORGANIZATION_PRIMARY_SOURCE
        : option.id === PROVIDED_BY_ID.ORGANIZATION_ADMIN;
    }
  } else {
    return responsibleRoles.length === option.roles.length;
  }
};
